import React, {PureComponent} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import './MoneyReportDialog.scss'
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {AppContext} from "../../../Utils/AppContext";
import TextField from "@material-ui/core/TextField";
import moment from 'moment';
import 'moment/locale/he';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/CloseRounded";
import OrderIcon from "../../../../Utils/Icons/SVGs/OrderIcon";

export default class MoneyReportDialog extends PureComponent {
    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {};
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (!this.props.open && nextProps.open) {
            const startTime = moment().startOf('day');
            const endTime = moment();

            this.setState({
                startTime: startTime.format(),
                startTimeText: startTime.format('YYYY-MM-DDTHH:mm'),
                endTime: endTime.format(),
                endTimeText: endTime.format('YYYY-MM-DDTHH:mm')
            });
        }
    }

    handleClose() {
        if (this.props.onClose)
            this.props.onClose();
    }

    handleDownload() {
        if (this.state.startTime && this.state.endTime) {
            const startTime = moment(this.state.startTime);
            const endTime = moment(this.state.endTime);

            if (startTime < endTime && endTime <= moment())
                this.downloadMoneyReport(this.state.startTime, this.state.endTime);
        }
    }

    downloadMoneyReport(startTime, endTime) {
        // Adding random number as url parameter so browser won't cache the downloaded file
        const randNumForCache = Math.floor(Math.random() * 1000000) + 1;
        const url = `/api/v2/reports/money?bid=${this.props.match.params.bid}&rand=${randNumForCache}&startTime=${startTime}&endTime=${endTime}`;
        const a = document.createElement("a");
        a.href = url;
        a.download = url.split("/").pop();
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
    }

    onStartTimeChanged(value) {
        const newStartTime = moment(value, 'YYYY-MM-DDTHH:mm');

        this.setState({
            startTimeText: value,
            startTime: newStartTime.isValid() ? newStartTime.format() : undefined
        });
    }

    onEndTimeChanged(value) {
        const newEndTime = moment(value, 'YYYY-MM-DDTHH:mm');

        this.setState({
            endTimeText: value,
            endTime: newEndTime.isValid() ? newEndTime.format() : undefined
        });
    }

    render() {
        let isErrorStartTime = true;
        let isErrorEndTime = true;

        if (this.state.startTime && this.state.endTime) {
            const startTime = moment(this.state.startTime);
            const endTime = moment(this.state.endTime);

            isErrorStartTime = startTime >= endTime;
            isErrorEndTime = endTime <= startTime || endTime > moment();
        }

        return (
            <div>
                <Dialog
                    scroll={'paper'}
                    className="money-report-dialog"
                    open={this.props.open}
                    onClose={this.handleClose.bind(this)}
                    aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">
                        <div className="money-report-dialog-title-content">
                            <OrderIcon/>
                            &nbsp;
                            דו״ח הזמנות
                        </div>
                    </DialogTitle>
                    <DialogContent dividers={true}>
                        <div className="dialog-content">
                            <TextField
                                id="datetime-local"
                                label="זמן התחלת הזמנות"
                                type="datetime-local"
                                error={isErrorStartTime}
                                value={this.state.startTimeText}
                                onChange={event => this.onStartTimeChanged(event.target.value)}
                            />
                            <div className="row-divider"/>
                            <TextField
                                id="datetime-local"
                                label="זמן סיום הזמנות"
                                type="datetime-local"
                                error={isErrorEndTime}
                                value={this.state.endTimeText}
                                onChange={event => this.onEndTimeChanged(event.target.value)}
                            />
                        </div>
                    </DialogContent>
                    <DialogActions className="dialog-actions">
                        <IconButton className="close-button"
                                    onClick={this.handleClose.bind(this)}>
                            <CloseIcon fontSize="small"/>
                        </IconButton>
                        <Button disabled={isErrorStartTime || isErrorEndTime} onClick={this.handleDownload.bind(this)}
                                color="primary" variant="contained" autoFocus>
                            הורד
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}